import type {
	DpIARecommendationItem,
	DpIARecommendationResponse,
} from 'integration/generated/transactions/data-contracts';
import type { RecommendationItem, RecommendationResponse } from '@/data/recom/types';

const toDpIARecommendationItem = ({
	vectorSource,
	scoreBreakdown,
	...item
}: RecommendationItem): DpIARecommendationItem => ({
	...item,
	vector_source: vectorSource as DpIARecommendationItem['vector_source'],
	score_breakdown: scoreBreakdown,
});

export const toDpIARecommendationResponse = ({
	data,
}: RecommendationResponse): DpIARecommendationResponse => ({
	data: {
		recommendations: (data?.recommendations ?? []).map(toDpIARecommendationItem),
		complements: data?.complements ?? [],
		outfits: data?.outfits ?? [],
		...(data?.sameBrand ? { sameBrand: data.sameBrand.map(toDpIARecommendationItem) } : {}),
		...(data?.family ? { family: data.family.map(toDpIARecommendationItem) } : {}),
	},
});
